import React, { createContext, useContext, useState } from "react";

const PaymentSuccessContext = createContext();

export const usePaymentSuccess = () => useContext(PaymentSuccessContext);

export function PaymentSuccessProvider({ children }) {
  const [show, setShow] = useState(false);
  const [data, setData] = useState(null);

  const openPaymentSuccess = (paymentData) => {
    setData(paymentData);
    setShow(true);
  };

  const closePaymentSuccess = () => {
    setShow(false);
    setData(null);
  };

  return (
    <PaymentSuccessContext.Provider
      value={{ show, data, openPaymentSuccess, closePaymentSuccess }}
    >
      {children}
    </PaymentSuccessContext.Provider>
  );
}
